export default "__VITE_ASSET__e0689702__"